import React from 'react';
// import Logo from './Logo';
import { Box, Backdrop, CircularProgress, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function SpinnerScreen({ open }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <Box position="relative" display="inline-flex">
        <CircularProgress size={100} thickness={1.5} color="secondary" />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img
            alt="Logo"
            src="/images/logoForLoading_2.png"
            width="50%"
            height="50%"
          />
        </Box>
      </Box>
    </Backdrop>
  );
}

SpinnerScreen.prototype = {
  open: PropTypes.bool
};

export default SpinnerScreen;
